import React from 'react';
import ReactDOM from 'react-dom';
import RedWolf from './RedWolf';

ReactDOM.render(
  <React.StrictMode>
    <RedWolf />
  </React.StrictMode>,
  document.getElementById('root')
);


